import React, { FC, ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { clsx } from 'clsx';
import { v4 as uuidv4 } from 'uuid';
// Components
import { Theme } from '@mui/material';
import ArrowButton from '../buttons/arrowButton';
import Separator from '../layout/separator';

export type EditButtonInfos = {
    title: string;
    subtitle?: string;
    subtitleView?: React.ReactNode;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    onClick?: () => void;
    pathRoute?: string;
    disabled?: boolean;
    color?: 'info' | 'danger';
    separator?: boolean;
    id?: string;
    arrowClassname?: string;
};

interface EditButtonListProps {
    buttonsEntries: EditButtonInfos[];
}

const EditButtonList: FC<EditButtonListProps> = ({ buttonsEntries }): ReactElement => {
    const classes = useStyles();

    const renderEditButtonList = (): JSX.Element[] => {
        if (buttonsEntries?.length) {
            return buttonsEntries.map((button: EditButtonInfos): JSX.Element => {
                const { color, separator, arrowClassname, ...props } = button;
                return (
                    <React.Fragment key={uuidv4()}>
                        <ArrowButton
                            {...props}
                            className={clsx(classes.arrowButton, color ? classes[color] : {}, arrowClassname)}
                        />
                        {separator ? <Separator /> : <Separator height={1} />}
                    </React.Fragment>
                );
            });
        }
        return null;
    };

    return <div className={classes.editButtonListRoot}>{renderEditButtonList()}</div>;
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        editButtonListRoot: {
            width: 'inherit',
            display: 'flex',
            flexDirection: 'column',
            '& .Mui-disabled': {
                opacity: 0.6,
            },
        },
        arrowButton: {
            padding: '16px 4px',
        },
        danger: {
            color: theme.palette.colors.text.error,
            '& .MuiTypography-root': {
                color: theme.palette.colors.text.error,
            },
        },
        info: {
            color: theme.palette.secondary.light,
            '& .MuiTypography-root': {
                color: theme.palette.secondary.light,
            },
        },
    }),
);

export default EditButtonList;
